import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Form from "../../../Utils/Form/Formik";
import { AddUser } from "../../../Services/Admin/Addmin";
import { getUserdata } from "../../../Services/Superadmin/Superadmin";
import { getUserFromToken } from "../../../Utils/TokenVerify";
const mcxSymbols = [
  "NATGASMINI",
  "SILVERM",
  "GOLDM",
  "SILVER",
  "GOLD",
  "COPPER",
  "CRUDEOIL",
  "CRUDEOILM",
  "NATURALGAS",
  "ZINC",
];

let CountryCodes = [
  { code: "+1", country: "USA" },
  { code: "+44", country: "UK" },
  { code: "+91", country: "India" },
  { code: "+61", country: "Australia" },
  { code: "+81", country: "Japan" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+86", country: "China" },
  { code: "+39", country: "Italy" },
  { code: "+7", country: "Russia" },
  // Add more country codes as needed
  { code: "+92", country: "Pakistan" },
  { code: "+880", country: "Bangladesh" },
  { code: "+966", country: "Saudi Arabia" },
  { code: "+971", country: "UAE" },
  { code: "+27", country: "South Africa" },
  { code: "+34", country: "Spain" },
  { code: "+55", country: "Brazil" },
  { code: "+52", country: "Mexico" },
  { code: "+82", country: "South Korea" },
  { code: "+60", country: "Malaysia" },
  { code: "+65", country: "Singapore" },
  { code: "+31", country: "Netherlands" },
  { code: "+46", country: "Sweden" },
  { code: "+41", country: "Switzerland" },
  { code: "+358", country: "Finland" },
  { code: "+353", country: "Ireland" },
  { code: "+64", country: "New Zealand" },
]

const AddUsers = () => {
  const permissions = localStorage.getItem("market")
  const navigate = useNavigate();
  const location = useLocation();
  const TokenData = getUserFromToken();
  const clientData = location.state?.clientData || {};
  const [data, setData] = useState([]);
  const Role = TokenData?.Role;
  const user_id = TokenData?.user_id;

  useEffect(() => {
    getAlluserdata();
  }, []);

  const formik = useFormik({
    initialValues: {
      fullName: clientData.FullName || "",
      username: clientData.UserName?.toString().toLowerCase() || "",
      email: "",
      countryCode: "",
      phone: clientData.PhoneNo || "",
      employee_id: "",

      password: clientData.password || "",
      confirmPassword: "",

      limit: "1",
      holding_limit: "1",
      option_selling_limit: "1",

      selectedOption: "",
      trade_block_time: "",
      inputValue: "",
      market: [],
      option_selling_permission: false,
      price_zero_status: false,
      hide_sell_button: false,
      option_status: false,
        mcxEnabled: false,     
  mcxData: {},            
    },

    validate: (values) => {
      let errors = {};

      if (!values.fullName) {
        errors.fullName = "Please Enter Full Name";
      }
      if (!values.username) {
        errors.username = "Please Enter Username";
      }
      if (!values.email) {
        errors.email = "Please Enter Email Address";
      } else if (!/^\S+@\S+\.\S+$/.test(values.email)) {
        errors.email = "Please enter a valid email address.";
      }
      if (!values.countryCode) {
        errors.countryCode = "Please select a country code";
      }
      if (!values.phone) {
        errors.phone = "Please Enter Phone Number";
      } else if (!/^\d{10}$/.test(values.phone)) {
        errors.phone = "Please enter a valid 10-digit phone number.";
      }

      if (!values.password) {
        errors.password = "Please Enter Password";
      } else if (values.password.length < 6) {
        errors.password = "Password must be at least 6 characters";
      }
      if (!values.confirmPassword) {
        errors.confirmPassword = "Please Confirm Password";
      } else if (values.password !== values.confirmPassword) {
        errors.confirmPassword = "Passwords do not match";
      }

      if (!values.limit) {
        errors.limit = "Please enter a value for Holding Limit";
      } else if (isNaN(values.limit) || values.limit < 0 || values.limit > 10000) {
        errors.limit = "Holding Limit should be a number between 0 and 10000";
      }
      if (!values.holding_limit) {
        errors.holding_limit = "Please enter a value for HOLDING limit";
      } else if (isNaN(values.holding_limit) || values.holding_limit < 0 || values.holding_limit > 10000) {
        errors.holding_limit = "HOLDING limit should be a number between 0 and 10000";
      }

      if (!values.option_selling_limit) {
        errors.option_selling_limit = "Please enter a value for OPTION SELLING limit";
      } else if (isNaN(values.option_selling_limit) || values.option_selling_limit < 0 || values.option_selling_limit > 10000) {
        errors.option_selling_limit = "OPTION SELLING limit should be a number between 0 and 10000";
      }


      if (!values.selectedOption) {
        errors.selectedOption = "Please select an option";
      }
      if (!values.inputValue) {
        errors.inputValue = "Please enter a value for the selected option";
      }

      if (values.market.length === 0) {
        errors.market = "Please select at least one market";
      }
      // if (!values.option_selling_permission) {
      //   errors.option_selling_permission = "Please select option selling permission";
      // }
      // if (!values.tradeType) {
      //   errors.tradeType = "Please select trade type";
      // }

      return errors;
    },

    onSubmit: async (values, { setSubmitting }) => {
      const selectedOption = values.selectedOption;

      const data = {
        FullName: values.fullName,
        UserName: values.username.toString().toLowerCase(),
        Email: values.email.toString().toLowerCase(),
        PhoneNo: values.countryCode + " " + values.phone,
        employee_id: values.employee_id,

        password: values.password,
        parent_role: Role || "ADMIN",
        parent_id: user_id,
        Role: "USER",
        limit: values.limit,
        holding_limit: values.holding_limit || 1,
        [selectedOption]: values.inputValue,
        referred_by: location?.state?.clientData?.referred_by || null,
        referral_price: location?.state?.clientData?.referral_price || 0,
        singleUserId: location?.state?.clientData?._id || null,
        option_selling_limit: values.option_selling_limit || 1,
        option_selling_permission: values.option_selling_permission,
        market: values.market,
         mcx: values.mcxEnabled
    ? values.mcxData
    : null,
        price_zero_status: values.price_zero_status,
        hide_sell_button: values.hide_sell_button,
        trade_block_time: values.trade_block_time,
        tradeType: values.tradeType,
        option_status: values.option_status ? 1 : 0,

      };

      setSubmitting(false);

      try {
        const response = await AddUser(data);
        if (response.status) {
          Swal.fire({
            title: "User Added!",
            text: "User added successfully",
            icon: "success",
            timer: 1000,
            timerProgressBar: true,
          });
          setTimeout(() => {
            navigate("/admin/users");
          }, 1000);
        } else {
          Swal.fire({
            title: "Error!",
            text: response.message || "User add error",
            icon: "error",
            timer: 1000,
            timerProgressBar: true,
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to add user. Please try again later.",
          icon: "error",
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },
  });

  const getAlluserdata = async () => {
    const data = { id: user_id };
    try {
      const response = await getUserdata(data);
      const result = response.data && response.data.filter((item) => item.Role === "EMPLOYE");
      setData(result);
    } catch (error) { }
  };



  const fields = [
  { type: "heading", label: "Basic Details", col_size: 12 },
    { name: "fullName", label: "Full Name", type: "text", label_size: 6, col_size: 6 },
    { name: "username", label: "Username", type: "text", label_size: 12, col_size: 6 },

    { name: "countryCode", label: "Country Code", type: "select", options: CountryCodes.map(c => ({ label: `${c.country} (${c.code})`, value: c.code })), label_size: 6, col_size: 2 },
    { name: "phone", label: "Phone Number", type: "text3", label_size: 12, col_size: 6 },
    { name: "email", label: "Email", type: "text", label_size: 12, col_size: 6 },




    {
      name: "employee_id",
      label: "Employee",
      type: "select",
      options: [
        ...(data
          ? data.map((item) => ({
            label: item.UserName,
            value: item._id,
          }))
          : []),
      ],
      label_size: 12,
      col_size: 6,
    },

    { name: "password", label: "Password", type: "password", label_size: 12, col_size: 6 },
    { name: "confirmPassword", label: "Confirm Password", type: "password", label_size: 12, col_size: 6 },
    { name: "holding_limit", label: "HOLDING Margin", type: "percentage", label_size: 12, col_size: 6, min: 0, max: 12 },
    { name: "limit", label: "INTRADAY Margin", type: "percentage", label_size: 12, col_size: 6, min: 0, max: 12 },
    { name: "option_selling_limit", label: "OPTION SELLING Margin", type: "percentage", label_size: 12, col_size: 6, min: 0, max: 12 },

    // {
    //   name: "option_selling_permission",
    //   label: "Forex Option Selling Permission",
    //   type: "toggle",
    //   col_size: 3,
    // },
    // {
    //   name: "hide_sell_button",
    //   label: "INR Hide Sell Button",
    //   type: "toggle",
    //   col_size: 3,
    // },

    // {
    //   name: "price_zero_status",
    //   label: "INR Zero price Status",
    //   type: "toggle",
    //   col_size: 3,
    // },



    {
      name: "selectedOption",
      label: "Brokerage",
      type: "select",
      options: [
        { value: "pertrade", label: "Per Trade" },
        { value: "perlot", label: "Per Lot" },
        { value: "transactionwise", label: "transtation wise" }
      ],
      label_size: 12,
      col_size: 6,
    },
    ...(formik.values.selectedOption
      ? [
        {
          name: "inputValue",
          label:
            formik.values.selectedOption === "pertrade"
              ? "Per Trade"
              : formik.values.selectedOption === "transactionwise"
                ? "Transaction-Wise %"
                : "Per Lot",
          type: "percentage",
          label_size: 12,
          col_size: 12,
        },
      ]
      : []),
    {
      name: "tradeType",
      label: "Client Trade Type",
      type: "select",
      options: [
        { value: 0, label: "Fund Wise" },
        { value: 1, label: "Per Trade" },
      ],
      label_size: 12,
      col_size: 6,
    },

    {
      name: "",
      label: "",
      type: "",
      col_size: 6,
    },

     { type: "heading", label: "Trade Block Duration & Select Market", col_size: 12 },
{
  name: "market_ui",
  type: "custom",
  col_size: 12,
},
    
  { type: "heading", label: "Permissions", col_size: 12 },
  ...(formik.values.market.includes(0)
  ? [
      {
        name: "option_selling_permission",
        label: "Forex Option Selling Permission",
        type: "toggle",
        col_size: 6,
      },
      {
        name: "option_status",
        label: "Forex Option Chain Price Zero Permission",
        type: "toggle",
        col_size: 6,
      },
    ]
  : [ ]),
 ...(formik.values.market.includes(1)
  ? [
      {
        name: "hide_sell_button",
        label: "INR Hide Sell Button",
        type: "toggle",
        col_size: 6,
      },
      {
        name: "price_zero_status",
        label: "INR Zero price Status",
        type: "toggle",
        col_size: 6,
      },
    ] : []),
    
  
  ];



  return (
    <Form
      fields={fields}
      page_title="Add User"
      btn_name="Add User"
      btn_name1="Cancel"
      formik={formik}
        TokenData={TokenData}  
          mcxSymbols={mcxSymbols}
      btn_name1_route={"/admin/users"}
//       additional_field={

//         <div className="col-lg-12 ">
//           <div className="mb-3 ">
//             <label className="fw-bold">Trade Block Duration</label>
//             <input
//               type="text"
//               className="form-control"
//               placeholder="mm:ss"
//               value={formik.values.trade_block_time || ""}
//               onChange={(e) => {
//                 let value = e.target.value;

//                 // Auto-format only mm:ss allowed
//                 if (/^[0-9]{0,2}(:[0-9]{0,2})?$/.test(value)) {
//                   formik.setFieldValue("trade_block_time", value);
//                 }
//               }}
//             />
//             <small className="text-muted">Format: mm:ss (Example: 05:30)</small>
//           </div>



//           <label className="fw-bold mb-2">Select Markets</label>
//           <div className="d-flex gap-4 align-items-center">
//             {/* Forex */}
//             {TokenData?.market.includes(0) &&
//               <div className="form-check">
//                 <input
//                   type="checkbox"
//                   className="form-check-input"
//                   id="market-forex"
//                   checked={formik.values.market.includes(0)}
//                   onChange={(e) => {
//                     if (e.target.checked) {
//                       formik.setFieldValue("market", [...formik.values.market, 0]);
//                     } else {
//                       formik.setFieldValue("market", formik.values.market.filter((m) => m !== 0));
//                     }
//                   }}
//                 />
//                 <label className="form-check-label " htmlFor="market-forex">Forex</label>
//               </div>}

//             {/* India */}
//             {TokenData?.market.includes(1) && <div className="form-check">
//               <input
//                 type="checkbox"
//                 className="form-check-input"
//                 id="market-india"
//                 checked={formik.values.market.includes(1)}
//                 onChange={(e) => {
//                   if (e.target.checked) {
//                     formik.setFieldValue("market", [...formik.values.market, 1]);
//                   } else {
//                     formik.setFieldValue("market", formik.values.market.filter((m) => m !== 1));
//                   }
//                 }}
//               />
//               <label className="form-check-label " htmlFor="market-india">India</label>
//             </div>}
//           </div>

//           {formik.errors.market && (
//             <div className="text-danger mt-2 small">{formik.errors.market}</div>
//           )}


//           {/* India selected hone ke baad button */}
// {formik.values.market.includes(1) && (
//   <div className="mt-3">
//     <button
//       type="button"
//       className="btn btn-primary btn-sm"
//       onClick={() =>
//         formik.setFieldValue("mcxEnabled", !formik.values.mcxEnabled)
//       }
//     >
//       Add MCX Symbols
//     </button>
//   </div>
// )}
  

// {/* MCX INPUT SECTION – FULL WIDTH */}
// {formik.values.market.includes(1) && formik.values.mcxEnabled && (
//   <div className="row mt-4">
//     <div className="col-12">

//       <div className="p-3  rounded shadow ">
//         <h6 className="fw-bold mb-3">MCX Symbols</h6>

//         <div className="row">
//           {mcxSymbols.map((symbol) => (
//             <div key={symbol} className="col-md-4 col-sm-6 mb-3">
//               <label className="form-label fw-semibold">
//                 {symbol}
//               </label>

//               <input
//                 type="number"
//                 className="form-control"
//                 placeholder={symbol}
//                 value={formik.values.mcxData?.[symbol] || ""}
//                 onChange={(e) => {
//                   formik.setFieldValue("mcxData", {
//                     ...formik.values.mcxData,
//                     [symbol]: e.target.value,
//                   });
//                 }}
//               />
//             </div>
//           ))}
//         </div>

//       </div>

//     </div>
//   </div>
// )}


//         </div>
        
//       }
    />


  );
};

export default AddUsers;